import {useSignal} from '@preact/signals-react'
import {Button} from 'antd'
import {Dialog} from 'primereact/dialog'
import React, {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useState,
} from 'react'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'
const StyledDeleteDialog = forwardRef(({onDelete}, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
    }))

    const formValue = useSignal({})

    const handleHideForm = useCallback(() => {
        unblockOverflownScroll()
        setVisible(false)
    }, [])

    const handleOnSubmit = () => {
        onDelete(formValue.value)
        setVisible(false)
    }

    // eslint-disable-next-line no-unused-vars
    const [visible, setVisible] = useState(false)

    const handleShowForm = data => {
        if (data) {
            formValue.value = data
        }

        blockOverflownScroll()
        setVisible(true)
    }

    return (
        <React.Fragment>
            <Dialog
                visible={visible}
                header={
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '12px',
                            padding: '8px 0',
                        }}>
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#fff2f0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '18px',
                            }}>
                            <i className="pi pi-exclamation-triangle text-red-500 text-xl"></i>
                        </div>
                        <h3
                            style={{
                                margin: 0,
                                fontSize: '18px',
                                fontWeight: 600,
                                color: '#262626',
                            }}>
                            Are you sure to delete this item?
                        </h3>
                    </div>
                }
                onHide={() => setVisible(!visible)}
                style={{
                    borderRadius: '16px',
                    minWidth: '400px',
                    maxWidth: '500px',
                    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.15)',
                    border: 'none',
                    overflow: 'hidden',
                }}
                footer={
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: '12px',
                            padding: '16px 0 8px 0',
                        }}>
                        <Button
                            onClick={() => setVisible(!visible)}
                            style={{
                                borderRadius: '8px',
                                border: '1px solid #d9d9d9',
                                background: '#fff',
                                color: '#595959',
                                fontWeight: 500,
                                padding: '8px 20px',
                                height: '36px',
                                transition: 'all 0.2s ease',
                            }}>
                            Cancel
                        </Button>
                        <Button
                            onClick={handleOnSubmit}
                            type="primary"
                            style={{
                                borderRadius: '8px',
                                background:
                                    'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',
                                border: 'none',
                                fontWeight: 600,
                                padding: '8px 20px',
                                height: '36px',
                                boxShadow: '0 2px 8px rgba(255, 77, 79, 0.3)',
                                transition: 'all 0.2s ease',
                            }}>
                            Delete
                        </Button>
                    </div>
                }>
                <div
                    style={{
                        padding: '16px 0',
                        textAlign: 'center',
                    }}>
                    <div
                        style={{
                            backgroundColor: '#fff7f7',
                            border: '1px solid #ffebe6',
                            borderRadius: '12px',
                            padding: '20px',
                            margin: '8px 0',
                        }}>
                        <span
                            style={{
                                color: '#ff4d4f',
                                fontSize: '16px',
                                fontWeight: 500,
                                lineHeight: '1.5',
                            }}>
                            This action cannot be undone. Are you sure you want
                            to permanently delete this item?
                        </span>
                    </div>
                </div>
            </Dialog>
        </React.Fragment>
    )
})

export default StyledDeleteDialog
